import {Container, Grid, Paper, Typography} from '@mui/material';
import React from 'react';
import PageSEO from '../../components/seo/PageSEO';
import './style.css';
import '../../components/testimonials/testimonials.css';
import TestimonialItemList from '../../components/testimonials/TestimonialItemList';
import TopTier from '../../components/testimonials/topTier/TopTier';
import {styled} from '@mui/material/styles';

const HeaderTitle = styled(Typography)(() => ({
  color: '#FFFFFF',
  textShadow: '0rem 0.29rem 0.29rem rgba(0, 0, 0, 0.25)',
  fontSize: '4.57142rem',
  wordWrap: 'break-word',
}));

const AboutSection = styled(Grid)(() => ({
  marginTop: '1.43rem',
}));

const AboutSecurSpace = styled(Paper)(({theme}) => ({
  paddingTop: '3.71rem',
  paddingRight: '5%',
  paddingLeft: '5%',
  paddingBottom: '3.71rem',
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.up('md')]: {
    padding: '3.71rem 5.14rem 0 5.14rem',
    height: '38.29rem',
  }
}));

const TruckImage = styled('img')(({theme}) => ({
  borderRadius: '0.71rem',
  display: 'flex',
  alignSelf: 'center',
  position: 'relative',
  marginTop: '2.15rem',
  objectfit: 'contain',
  height: 'auto',
  width: '100%',
  [theme.breakpoints.up('md')]: {
    maxHeight: '33.5rem',
    width: '100%',
    objectfit: 'cover',
  }
}));

const TestimonialsSection = styled('section')(({theme}) => ({
  marginTop: '7.07rem', // manually push section down b.c. truck image overflow
  [theme.breakpoints.up('md')]: {
    marginTop: '19.07rem'
  }
}));

const TestimonialsDescription = styled(Typography)(({theme}) => ({
  color: theme.palette.text.disabled,
}));

const AboutText = styled(Typography)(() => ({
  fontSize: '1.71em',
  fontWeight: '400',
  lineHeight: '133.4%',
  color: '#000000',
  fontFamily: 'Inter',
}));

const AppContainer = styled(Container)(() => ({
  maxWidth: '92.71rem !important',
}));

const About = () => {
  return (
    <article className='ss-about w-100'>
      <PageSEO
        title="About SecurSpace | Semi Truck Parking Nationwide"
        description="SecurSpace is an online marketplace that connects companies looking for parking and storage options to those with dedicated or excess capacity."
        keywords="semi truck parking"
        canonicalUrl="https://secur.space/about"
      />
      <AppContainer>
        <HeaderTitle variant='h1' align='center'>About SecurSpace</HeaderTitle>
        <AboutSection container justifyContent='center' component="section">
          <AboutSecurSpace elevation={1}>
            <AboutText variant='h5' component='p' align='center'>
              SecurSpace is an online marketplace that connects companies looking for parking and storage options to
              those with dedicated or excess capacity. Our platform was built to combat issues caused by the lack of
              adequate space in cities and near major highways and interstates. Businesses and individuals around the
              world contend with this issue on a daily basis - solving this problem is our specialty.
            </AboutText>
            <TruckImage src='/app-images/about/image-trucks.png' alt='trucks'/>
          </AboutSecurSpace>
        </AboutSection>
        <TestimonialsSection>
          <div className="ss-customer-partner-testimonials-head">
            <Typography variant="h3" color="textPrimary" component="h2" align='center'>Supported by top-tier buyers and
              suppliers across the globe</Typography>
            <TestimonialsDescription variant="overline">Testimonials</TestimonialsDescription>
          </div>
          <TestimonialItemList/>
          <TopTier/>
        </TestimonialsSection>
      </AppContainer>
    </article>
  );
};

export default About;
